import * as entity from '@common/domain/entities/Invoice'
import { IDataEndPoint, IColumnOptions } from '../../../framework/interfaces/IEntity';
import * as app from '@framework/app';
import { IApiServiceCommand } from '../../../services/api/api.service';
export class InvoiceEndPoints extends entity.InvoiceEndPoints {
  search?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/invoice/search/", method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/invoice/searchCount/", method: "POST" };
}


export class InvoiceFullEndPoints extends entity.InvoiceEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/lazy/" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/lazyCount/" }, method: "POST" };
}

export class InvoiceFormFields extends entity.InvoiceFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class InvoiceForm extends entity.InvoiceForm {
  protected invoiceFormEndPoints: InvoiceEndPoints = new InvoiceEndPoints();
  protected invoiceFormFields: InvoiceFormFields = new InvoiceFormFields();
}

export class InvoiceListColumns extends entity.InvoiceListColumns {

  public siteName: IColumnOptions = { field: "siteName", name : "Site"};
  constructor() {
    super();
	    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
    this.splice(0,this.length)
    this.push({ field: 'id', visible: false });
    this.push({
      "field": "jobCardNo", "dbField": "jobCardNo", "name": "Job Card No", "fieldType": 0, "readOnly": true, "filterMatchMode": "contains",
      "formBuilderControl": { "controlType": { "viewType": 0 }, "displayName": "Job Card No", "bindingValue": "jobCardNo", "field": "jobCardNo" }
    });
    this.push({
      "field": "originalPurchaseOrderNo", "dbField": "originalPurchaseOrderNo", "name": "Original Purchase Order No", "fieldType": 0, "readOnly": true, "filterMatchMode": "contains",
      "formBuilderControl": { "controlType": { "viewType": 0 }, "displayName": "Original Purchase Order No", "bindingValue": "originalPurchaseOrderNo", "field": "originalPurchaseOrderNo" }
    });
    this.push({ "field": "workOrderNo", "dbField": "workOrderNo", "name": "Work Order No", "fieldType": 0, "readOnly": true, "filterMatchMode": "contains", "formBuilderControl": { "controlType": { "viewType": 0 }, "displayName": "Work Order No", "bindingValue": "workOrderNo", "field": "workOrderNo" } });
    this.push({
      "field": "headOfficeInvoiceWorkFlowStatus",
      "template": function (fldValue) {
        if (!fldValue) return ""; 
        if (fldValue == 0) return "Not Sent";
        if (fldValue == 1) return "Pending";
        if (fldValue == 2) return "Complete";
      },
      "dbField": "headOfficeInvoiceWorkFlowStatus", "name": "HO Workflow status", "fieldType": 0, "readOnly": true, default: "1",
      "filterMatchMode": "contains", "formBuilderControl": {
        "controlType": { "viewType": 1 }, "displayName": "HO Workflow status", "bindingValue": "headOfficeInvoiceWorkFlowStatus", "field": "headOfficeInvoiceWorkFlowStatus", lookups: [

          {
            label: 'Not Sent',
            value: '0'
          },
          {
            label: 'Pending',
            value: '1'
          },
          {
            label: 'Complete',
            value: '2'
          }]
      }
    });
    this.push({
      "field": "requestType",
      "template": function (fldValue) {
        if (!fldValue) return "";
        if (fldValue == 0) return "None";
        if (fldValue == 1) return "Credit Note";
        if (fldValue == 2) return "Invoice No";
      },
      "dbField": "requestType", "name": "Request Type", "fieldType": 0, "readOnly": true, "filterMatchMode": "contains", "formBuilderControl": {
        "controlType": { "viewType": 1 }, "displayName": "Request Type", "bindingValue": "requestType", "field": "requestType", lookups: [

          {
            label: 'None',
            value: '0'
          },
          {
            label: 'Credit Note',
            value: '1'
          },
          {
            label: 'Invoice No',
            value: '2'
          }
        ]
      }
    });
    //this.push(this.requestTypeId);
    this.push(this.creditNoteNo);
    this.push(this.invoiceNo);
    this.push(this.siteName);
    this.push({
      "field": "itemType",
      template: function (fldValue) {
        if (!fldValue) return "";
        if (fldValue == 0) return "Invoice";
        if (fldValue == 1) return "Credit Note";
        if (!fldValue) return "";
      },
      "dbField": "itemType", "name": "Item Type", "fieldType": 0, "readOnly": true, default: "",
      "filterMatchMode": "contains", "formBuilderControl": {
        "controlType": { "viewType": 1 }, "displayName": "Item Type", "bindingValue": "itemType", "field": "itemType", lookups: [
          {
            label: 'Invoice',
            value: '0'
          },
          {
            label: 'Credit Note',
            value: '1'
          }]
      }
    });
  }
}

export class InvoiceFullListColumns extends entity.InvoiceListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class InvoiceList extends entity.InvoiceList {
  protected invoiceListEndPoints: InvoiceEndPoints = new InvoiceEndPoints();
  protected invoiceListColumns: InvoiceListColumns = new InvoiceListColumns();
}

export class InvoiceFullList extends entity.InvoiceList {
  protected invoiceListEndPoints: InvoiceFullEndPoints = new InvoiceFullEndPoints();
  protected invoiceListColumns: InvoiceFullListColumns = new InvoiceFullListColumns();
}




